import React, { useState } from 'react'
import axiosClient from '../api/axiosClient';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export default function ModalFormAddMobileMoneyCard({ isModalOpen, closeModal, onSuccess }) {

    const [loading, setLoading] = useState(false);
    const [validationError, setValidationError] = useState('');
    const [number, setNumber] = useState("");
    const [errors, setErrors] = useState({});
    const imagePath = process.env.REACT_APP_IMAGE_PATH;
    

    // Fonction de validation du numéro
    const validatePhoneNumber = (phoneNumber) => {
        try {
            const parsedNumber = parsePhoneNumberFromString(phoneNumber); 
            if (parsedNumber && parsedNumber.isValid()) {
                return ''; // Pas d'erreur, le numéro est valide
            }
            return 'Veuillez entrer un numéro de téléphone valide avec le code pays (par ex. +225 0102030405).';
        } catch (error) {
            return 'Numéro de téléphone invalide.';
        }
    };

    // Fonction de validation des champs
    const validateFields = () => {
        const validationErrors = {};
        const trimmedNumber = number.trim();

        if (!trimmedNumber) {
            validationErrors.number = 'Veuillez saisir un numéro de téléphone.';
        } else {
            const phoneError = validatePhoneNumber(trimmedNumber);
            if (phoneError) validationErrors.number = phoneError;
        }

        return validationErrors;
    };

    // Fonction pour gérer la soumission du formulaire
    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validateFields();
        setErrors(validationErrors);

        // Si des erreurs existent, on arrête l'exécution
        if (Object.keys(validationErrors).length > 0) return;

        // Création des données de formulaire
        const formData = new FormData();
        formData.append('number', number);

        setLoading(true);

        axiosClient.post('/request/user/manageAccount/payement/add-card/mobile-wave-account', formData)
            .then(
                ({data}) => {
                    onSuccess(data.message);
                    setLoading(false);
                    closeModal();

            }).catch(err => {
                const response = err.response;
                if (response) {
                    // console.log("Erreur de l'API :", response);
                    if (response.status === 422) {
                        setValidationError("Erreur ! Veuillez vérifier vos informations puis réessayer s'il vous plait !");
                    }else if (response.status === 500) {
                        if (response.data.errors) {
                            // Erreurs spécifiques aux champs
                            setErrors(response.data.errors);
                        }
                        if (response.data.message) {
                            // Erreur générale
                            setValidationError(response.data.message);
                        }
                    }
                    setLoading(false);
                    setTimeout(() => setValidationError(""), 7000);
                } else {
                    setValidationError("Erreur lors de l'ajout de la carte.");
                    setLoading(false);
                    setTimeout(() => setValidationError(""), 7000);
                }
            })
    };

    const isSubmitDisabled = () => {
        return loading;
    };

    return (
        isModalOpen && (
            <div className='inset-0 z-10 w-screen overflow-y-auto fixed bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center' style={{
                zIndex: 100,
                top: 0,
                width: "100%",
                height: "100%",
                overflowX: "hidden",
                overflowY: "auto",
                outline: 0,
                left: 0,
                margin: 0,
            }}>
                <div
                    className="flex items-center justify-center cxe43 cnbwt cini7 cjxg0 cys4p codu7 clbq0"
                    role="dialog"
                    aria-modal="true">
                    {validationError && (
                        <div className="text-sm fixed mt-4 top-0 z-10 cf8dr cb8zv cvkq6 clbq0 cuvgf">
                            <div className="flex cm3rx ce4zk c6btv">
                                <div className="flex">
                                <svg
                                    className="cbm9w czr3n cq1qg coqgc chfzq"
                                    width={16}
                                    height={16}
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.5 10.1l-1.4 1.4L8 9.4l-2.1 2.1-1.4-1.4L6.6 8 4.5 5.9l1.4-1.4L8 6.6l2.1-2.1 1.4 1.4L9.4 8l2.1 2.1z" />
                                </svg>
                                <div>{validationError}</div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="bg-white rounded-lg w-96 flex cm4ey p-5">
                        
                        {/* <div> */}
                        <div className="w-full">
                            <div className="flex items-center cp3jk c6r0l">
                                <img
                                className="rounded-full coqgc"
                                src={`${imagePath}images/wave-logo.png`}
                                width={40}
                                height={40}
                                alt="Logo wave"
                                />
                                <div className="cbw8w">
                                <input
                                    style={{ backgroundColor: 'rgb(243 244 246 / 1) !important' }}
                                    id=""
                                    className="caqf9 c6btv c9hxi cwn3v focus:border-gray-200 focus:ring-transparent"
                                    type="text"
                                    placeholder="Par ex : +225 0102030405"
                                    required
                                    value={number}
                                    onChange={(e) => setNumber(e.target.value)}
                                />
                                {errors.number && (
                                    <small className="text-red-600 mt-2">
                                        {errors.number}
                                    </small>
                                )}
                                </div>
                            </div>
                            <div className="flex flex-wrap justify-end ch3kz">
                                <button onClick={closeModal} className="border-gray-200 text-gray-800 cc0oq cghq3 cspbm c0zkc cnf4p">
                                Annuler
                                </button>
                                <button onClick={handleSubmit} disabled={isSubmitDisabled()} className="text-white c8ham bg-primary-6000 cpcyu cnf4p hover:bg-primary-700">
                                    {loading ? (
                                        <>
                                            <svg
                                                className="animate-spin -ml-1 mr-3 h-5 w-5 ml-3"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <circle
                                                    className="opacity-25"
                                                    cx={12}
                                                    cy={12}
                                                    r={10}
                                                    stroke="currentColor"
                                                    strokeWidth={3}
                                                />
                                                <path
                                                    className="opacity-75"
                                                    fill="currentColor"
                                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                />
                                            </svg>
                                            Un instant...
                                        </>
                                        ) : (
                                        <>Enregistrer</>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    )
}
